import { formatLongDateTimeInSA } from './format-date.js';
/**
 * Formats an ISO date string as a relative time (e.g. "5m ago", "2d ago").
 * Falls back to Bill's en-ZA long date for anything older than a week.
 */
export function formatRelativeTime(dateStr) {
    const now = Date.now();
    const then = new Date(dateStr).getTime();
    const diffMs = now - then;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHr / 24);
    if (diffSec < 60)
        return 'Just now';
    if (diffMin < 60)
        return `${diffMin}m ago`;
    if (diffHr < 24)
        return `${diffHr}h ago`;
    if (diffDays < 7)
        return `${diffDays}d ago`;
    return formatLongDateTimeInSA(dateStr);
}
